import { getFeatureFlag } from './shell-helpers'
import { UnleashFlags } from '../models/feature-flag.models'

type OriginTrialTokenKey =
  | 'localhost-chrome'
  | 'localhost-edge'
  | 'dev-chrome'
  | 'dev-edge'
  | 'ed-chrome'
  | 'ed-edge'
  | 'stage-chrome'
  | 'stage-edge'
  | 'staging-chrome'
  | 'staging-edge'
  | 'rc-chrome'
  | 'rc-edge'
  | 'nightly-chrome'
  | 'nightly-edge'
  | 'prod-chrome'
  | 'prod-edge'

export type OriginTrialBrowser = 'chrome' | 'edge'

export type OriginTrialTokenMap = Partial<Record<OriginTrialTokenKey, string>>

const DEFAULT_ORIGIN_TRIAL_TOKENS: OriginTrialTokenMap = {
  'localhost-chrome': '',
  'localhost-edge': '',
  'dev-chrome': '',
  'dev-edge': '',
  'ed-chrome': '',
  'ed-edge': '',
  'stage-chrome': '',
  'stage-edge': '',
  'staging-chrome': '',
  'staging-edge': '',
  'rc-chrome': '',
  'rc-edge': '',
  'nightly-chrome': '',
  'nightly-edge': '',
  'prod-chrome': '',
  'prod-edge': '',
}

export const getCurrentEnvironmentFromUrl = (hostname: string): string => {
  const host = String(hostname).toLowerCase().trim()

  if (host === 'localhost') {
    return 'localhost'
  }

  if (host.includes('.ed.')) {
    return 'ed'
  }

  if (host.includes('.dev.')) {
    return 'dev'
  }

  if (host.includes('.rc.')) {
    return 'rc'
  }

  if (host.includes('.staging.')) {
    return 'staging'
  }

  if (host.includes('.stage.')) {
    return 'stage'
  }

  if ( host.includes('.nightly.')) {
    return 'nightly'
  }

  return 'prod'
}

export const getOriginTrialToken = (
  tokenMap: OriginTrialTokenMap | undefined,
  currentEnvironment: string,
  browser: OriginTrialBrowser,
): string | undefined => {
  if (!tokenMap) {
    return undefined
  }

  const key = `${currentEnvironment}-${browser}` as OriginTrialTokenKey
  return tokenMap[key]
}

const getCurrentBrowser = (): OriginTrialBrowser | 'unsupported' => {
  const userAgent = navigator.userAgent

  if (userAgent.includes('Edg/') || userAgent.includes('Edge/')) {
    return 'edge'
  }

  if (/Trident\//.test(userAgent) || /MSIE /.test(userAgent)) {
    return 'unsupported'
  }

  if (userAgent.includes('Chrome/') || userAgent.includes('CriOS/')) {
    return 'chrome'
  }

  return 'unsupported'
}

export const applyOriginTrialMetaTag = (): HTMLMetaElement | null => {
  try {
    const tokenMap = getFeatureFlag<OriginTrialTokenMap>(
      UnleashFlags.USER_MEDIA_ELEMENT_ORIGIN_TRIAL_TOKENS,
      DEFAULT_ORIGIN_TRIAL_TOKENS,
    )
    const browser = getCurrentBrowser()

    if (browser === 'unsupported') {
      return null
    }

    const currentEnvironment = getCurrentEnvironmentFromUrl(location.hostname)
    const token = getOriginTrialToken(tokenMap, currentEnvironment, browser)

    if (!token) {
      return null
    }

    const metaTag = document.createElement('meta')
    metaTag.setAttribute('http-equiv', 'origin-trial')
    metaTag.setAttribute('content', token)
    document.head.appendChild(metaTag)

    return metaTag as HTMLMetaElement
  } catch {
    return null
  }
}
